module.exports = __webpack_public_path__ + "img/423-95d258.png";